module.exports = __webpack_public_path__ + "static/media/squared.95cf7661.jpg";